import { api, ReactQueryOptions } from '@api';
import { useSession } from '@shared/hooks/useSession';
import { localStorageService } from '@specs/features/storage';
import { useShowToast } from '@hooks/useShowToast';
type optionsType = ReactQueryOptions['PostsManager']['viewPost'];
export const useViewPost = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const utils = api.useUtils();
  const {
    status
  } = useSession();
  if (status === 'unauthenticated') {
    return api.PostsManager.viewPostPublic.useMutation({
      ...options,
      mutationKey: ['PostsManager.viewPublicPost'],
      onError: () => {
        showToast({
          variant: 'error',
          text: 'error.default'
        });
      },
      onSuccess: async ({}, {
        post_id
      }) => {
        localStorageService.add('viewedPosts', post_id);
        await utils.PostsManager.getPublicFeed.invalidate();
        await utils.PostsManager.getPost.invalidate({
          post_id
        });
      }
    });
  }
  return api.PostsManager.viewPost.useMutation({
    ...options,
    mutationKey: ['PostsManager.viewPost'],
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    onSuccess: async ({}, {
      post_id
    }) => {
      localStorageService.add('viewedPosts', post_id);
      await utils.PostsManager.getAuthorFeed.invalidate();
      await utils.PostsManager.getPersonalFeed.invalidate();
      await utils.PostsManager.getPost.invalidate({
        post_id
      });
    }
  });
};